(() => {
  function init(root) {
    const track = root.querySelector("[data-ze-track]");
    const slides = Array.from(root.querySelectorAll("[data-ze-slide]"));
    const dotsWrap = root.querySelector("[data-ze-dots]");
    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll("[data-ze-dot]")) : [];

    if (!track || slides.length === 0) return;

    let index = 0;
    let timer = null;

    const autoplay = root.getAttribute("data-autoplay") === "true";
    const interval = Number(root.getAttribute("data-interval") || 6000);

    const setActiveDot = () => {
      dots.forEach((d) => d.classList.remove("is-active"));
      if (dots[index]) dots[index].classList.add("is-active");
    };

    const go = (i) => {
      index = (i + slides.length) % slides.length;
      track.style.transform = `translate3d(${-index * 100}%, 0, 0)`;
      setActiveDot();

      // If slide contains video and autoplay is enabled, try play it
      slides.forEach((s, si) => {
        const v = s.querySelector("video");
        if (!v) return;
        if (si === index) {
          if (autoplay) v.play().catch(() => {});
        } else {
          v.pause();
        }
      });
    };

    const start = () => {
      if (!autoplay || slides.length < 2) return;
      stop();
      timer = setInterval(() => go(index + 1), interval);
    };

    const stop = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };

    // Dots
    dots.forEach((d) => {
      d.addEventListener("click", () => {
        const i = Number(d.getAttribute("data-ze-dot"));
        go(i);
        start();
      });
    });

    // Pause on hover (desktop)
    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);

    // Fix Shopify editor “white box” refresh issues
    const onResize = () => go(index);
    window.addEventListener("resize", onResize);

    // init state
    go(0);
    start();

    // cleanup hook for safety (optional)
    root.__zeCleanup = () => {
      stop();
      window.removeEventListener("resize", onResize);
    };
  }

  function boot() {
    document.querySelectorAll("[data-ze-slideshow]").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", boot);

  // Shopify theme editor support
  document.addEventListener("shopify:section:load", (e) => {
    const root = e.target.querySelector("[data-ze-slideshow]") || e.target.closest("[data-ze-slideshow]");
    if (root) init(root);
  });

  document.addEventListener("shopify:section:unload", (e) => {
    const root = e.target.querySelector("[data-ze-slideshow]") || e.target.closest("[data-ze-slideshow]");
    if (root && root.__zeCleanup) root.__zeCleanup();
  });
})();